import "bootswatch/dist/darkly/bootstrap.min.css";
import Dashboard from "./Components/Root/Dashboard";
import "./index.css";
import { BrowserRouter as Router } from 'react-router-dom';
import axios from "axios";
import { useEffect, useState } from "react";
import Cookies from "universal-cookie"


function App() {
  const [tokenLoaded, setTokenLoaded] = useState(false);
  const [token, setToken] = useState(null);
  const cookies = new Cookies();
  useEffect(() => {
    axios.get("https://adres.trabzon.bel.tr/key/")
      .then((res) => {
        const newToken = res.data.key;
        cookies.set("key", newToken, { path: "/" });

        setToken(newToken);
        setTokenLoaded(true);
      });
  }, []);

  return (
    <Router>
      <Dashboard tokenLoaded={tokenLoaded} token={token} />
    </Router>
  );
}

export default App;
